import { render, staticRenderFns } from "./MfaSetupForm.vue?vue&type=template&id=0e126819&scoped=true&"
import script from "./MfaSetupForm.vue?vue&type=script&lang=js&"
export * from "./MfaSetupForm.vue?vue&type=script&lang=js&"
import style0 from "./MfaSetupForm.vue?vue&type=style&index=0&id=0e126819&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e126819",
  null
  
)

export default component.exports